import React from 'react';

import Parties from '../companies/Parties'

const TitleTransferMinifiedCounterParties = ({ selectedTitleTransfer }) => {
  return (
    <Parties
      parties={[
        {...selectedTitleTransfer?.seller, sectionName: "Seller", name: selectedTitleTransfer?.seller?.companyName},
        {...selectedTitleTransfer?.buyer, sectionName: "Buyer", name: selectedTitleTransfer?.buyer?.companyName},
      ]}
    />
  );
}

export default TitleTransferMinifiedCounterParties;
